export const FORMULARIO_BATERIA = 'FORMULARIO_BATERIA';
export const OBTENER_BATERIAS = 'OBTENER_BATERIAS';
export const AGREGAR_BATERIA = 'AGREGAR_BATERIA';
export const BATERIA_ACTUAL = 'BATERIA_ACTUAL';
export const ELIMINAR_BATERIA = 'ELIMINAR_BATERIA';
export const EDITAR_BATERIA = 'ELIMINAR_BATERIA';

export const MOSTRAR_ALERTA = 'MOSTRAR_ALERTA';
export const OCULTAR_ALERTA = 'OCULTAR_ALERTA';

export const REGISTRO_EXITOSO = 'REGISTRO_EXITOSO';
export const REGISTRO_ERROR = 'REGISTRO_ERROR';
export const OBTENER_USUARIO = 'OBTENER_USUARIO';
export const LOGIN_EXITOSO = 'LOGIN_EXITOSO';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const CERRAR_SESION = 'CERRAR_SESION';

export const TIENDA_BATERIAS = 'TIENDA_BATERIAS';
export const TIENDA_COMPRA = 'TIENDA_COMPRA';
export const COMPRA_BATERIA = 'COMPRA_BATERIA';
export const COMPRA_ERROR = 'COMPRA_ERROR';
export const MENSAJE_TIENDA = 'MENSAJE_TIENDA';
